// Small display formatters shared across the app.

// "2h 58m" from a minute count (null-safe; 0 / negative / NaN → null).
export function formatRuntime(minutes) {
	if (!Number.isFinite(minutes) || minutes <= 0) return null;
	const h = Math.floor(minutes / 60);
	const m = minutes % 60;
	if (h === 0) return `${m}m`;
	return m === 0 ? `${h}h` : `${h}h ${m}m`;
}
